"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.whiteLabelConfig = exports.contextOf = exports.serverSide = exports.whiteLabelFeature = exports.experiment = exports.domainName = exports.whiteLabelId = exports.origin = exports.deviceType = exports.culture = exports.noCondition = exports.not = exports.With = void 0;
var ParenthesisCondition_1 = __importDefault(require("./ParenthesisCondition"));
var IntermediateResolverConditionBuilder_1 = __importDefault(require("./builders/IntermediateResolverConditionBuilder"));
var IntermediateLookupResolverConditionBuilder_1 = __importDefault(require("./builders/IntermediateLookupResolverConditionBuilder"));
var ConditionBuilder_1 = __importDefault(require("./builders/ConditionBuilder"));
var builders_1 = require("./builders");
var IntermediateContextualConditionBuilder_1 = __importDefault(require("./builders/IntermediateContextualConditionBuilder"));
var Variant_1 = require("../behaviorManager/constants/Variant");
var IntermediateConfigConditionBuilder_1 = __importDefault(require("./builders/IntermediateConfigConditionBuilder"));
var WhiteLabelConfigExtractor_1 = __importDefault(require("../extractor/WhiteLabelConfigExtractor"));
var With = function (conditionBuilder) {
    return new ConditionBuilder_1.default(new ParenthesisCondition_1.default(conditionBuilder.build()));
};
exports.With = With;
exports.not = new builders_1.IntermediateBuilder({
    invert: true,
});
exports.noCondition = {
    evaluate: function () { return true; },
    describe: function () { return 'No condition'; },
};
exports.culture = new IntermediateResolverConditionBuilder_1.default(Variant_1.Variant.Culture);
exports.deviceType = new IntermediateResolverConditionBuilder_1.default(Variant_1.Variant.DeviceType);
exports.origin = new IntermediateResolverConditionBuilder_1.default(Variant_1.Variant.Origin);
exports.whiteLabelId = new IntermediateResolverConditionBuilder_1.default(Variant_1.Variant.WhiteLabelId);
exports.domainName = new IntermediateResolverConditionBuilder_1.default(Variant_1.Variant.DomainName);
exports.experiment = new IntermediateLookupResolverConditionBuilder_1.default(Variant_1.Variant.Experiment);
exports.whiteLabelFeature = new IntermediateLookupResolverConditionBuilder_1.default(Variant_1.Variant.WhiteLabelFeature);
exports.serverSide = new IntermediateLookupResolverConditionBuilder_1.default(Variant_1.Variant.ServerSideBehavior);
var contextOf = function (name, predicate) {
    return new IntermediateContextualConditionBuilder_1.default(name, predicate);
};
exports.contextOf = contextOf;
var whiteLabelConfig = function (featureName) {
    return new IntermediateConfigConditionBuilder_1.default('whiteLabelConfig', (0, WhiteLabelConfigExtractor_1.default)(featureName));
};
exports.whiteLabelConfig = whiteLabelConfig;
